import { ApolloClient, useApolloClient } from '@apollo/client';
import React, { PropsWithChildren, ReactElement } from 'react';

import { ApolloPageClient } from '../Apollo/apolloPageClient';

import { PageFetcherProvider } from './PageFetcherProvider';

export function ApolloPageClientProvider (props: PropsWithChildren<any>): ReactElement {
    const { children }: PropsWithChildren<any> = props;
    // eslint-disable-next-line @typescript-eslint/ban-types
    const apolloClient: ApolloClient<object> = useApolloClient();
    const client: ApolloPageClient = new ApolloPageClient(apolloClient);

    return (
        <PageFetcherProvider fetcher={client}>
            {children}
        </PageFetcherProvider>
    );
}
